import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Member } from "../../models/interfaces/member.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

import { ViewController } from "ionic-angular";

@Component({
  selector: "harecomponent",
  templateUrl: "harecomponent.html"
})
export class HareComponent {
  private distinct_status = [];
  private selectedMember: Member[] = [];
  private member_All = [];
  private member_by_status = [];
  private tmpSearchObject_by_status = [];
  private member$: any;
  private member = [];
  private hares: any;
  private tmp_member = [];
  private tmpSearchObject;
  private listForm: FormGroup;
  private sel = [];
  private arrayText = [];
  private st_id: number = 2;
  private cnt: number = -1;
  private hl_id: number = -1;
  private hl_runno: number;
  private hl_datetime: string;
  private type;
  private segmember: string = "Regular";
  private styleName: string ="";
  private whereclause: string;

  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public alertCtrl: AlertController,
              private db: DbserviceProvider, public viewCtrl: ViewController, private configService: ConfigService) {
    console.log("HareComponent constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    let tmp: string = this.navParams.get("sel");
    let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");

    if (tmp !== undefined) {
      this.sel = tmp.split(",");
      // this.selectedMember = this.sel;
    }
    this.type = this.navParams.get("type");
    this.db.dbCol({
      "action": "select", "mapObject": "vw_member",
      "sqlExtended": "  order by st_order, mb_hashname "}).subscribe((el) => {

        this.member_All =el;
        this.distinct_status = this.member_All.reduce((prev, { st_id, st_name }) =>
        prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
      this.distinct_status.push()
      this.distinct_status.push({
        st_id: 99,
        st_name: 'All Members',
      });
      this.distinct_status.forEach((element, index, array) => {

        if (element.st_id==99 ){
          this.member_by_status[element.st_id]=this.member_All;

        }else{
          this.member_by_status[element.st_id]=this.member_All.filter(data => data.st_name == element.st_name);
        }
        // The tmp object contains all elements, this is used to reset during search
        this.tmpSearchObject_by_status[element.st_id]=this.member_by_status[element.st_id];
      });

      el.map((mbr) => {
        this.sel.forEach((s) => {
          if (s === mbr.mb_hashname) {
            this.selectedMember.push(mbr);
          }
        });
      });
    });
  }

  private ionViewWillEnter() {
    console.log("HareComponent ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("HareComponent onInitPage");
    this.tmp_member = [];
    this.cnt = -1;
    this.hl_id = -1;
    let mbrDefault = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY");
    let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");
    if(this.st_id==99){
      this.whereclause=" where 1=1 "
    }
    else{
      this.whereclause=" where st_id= " + this.st_id;
    }

    this.db.dbCol({
      "action": "select",
      "mapObject": "vw_listhares_by_last_hashdate",
      "sqlExtended": this.whereclause,
    }).subscribe((ret) => {
      this.member = ret;
      ret.forEach((el) => {

        // Create the array in case a new listing of a hashname
        if (this.tmp_member[el.mb_hashname] === undefined || this.tmp_member[el.mb_hashname] === null) {
          this.tmp_member[el.mb_hashname] = [];
        }
        this.tmp_member[el.mb_hashname].hl_id = el.hl_id;
        this.tmp_member[el.mb_hashname].hl_runno = el.hl_runno;
        this.tmp_member[el.mb_hashname].hl_datetime = el.hl_datetime;
        this.tmp_member[el.mb_hashname].mb_id = el.mb_id;
        this.tmp_member[el.mb_hashname].mb_hashname = el.mb_hashname;
        this.tmp_member[el.mb_hashname].mb_photo = el.mb_photo;
        // Create the runs array in case it does not exist
        if (this.tmp_member[el.mb_hashname].runs === undefined || this.tmp_member[el.mb_hashname].runs === null) {
          this.tmp_member[el.mb_hashname].runs = [];
          this.cnt = -1;
          this.hl_id = -1;
        }
        // The count of the run array needs to be increased in case it is a new run, meaning new hl_id.
        if (this.hl_id !== el.run_hl_id) {
          this.cnt = this.cnt + 1;
          if (this.tmp_member[el.mb_hashname].runs[this.cnt] === undefined || this.tmp_member[el.mb_hashname].runs[this.cnt] === null) {
            this.tmp_member[el.mb_hashname].runs[this.cnt] = [];
          }
        }
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_hl_id = el.run_hl_id;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_hl_runno = el.run_hl_runno;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_hl_datetime = el.run_hl_datetime;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_mb_id = el.run_mb_id;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_mb_hashname = el.run_mb_hashname;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_st_id = el.run_st_id;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_st_name = el.run_st_name;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_hs_type = el.run_hs_type;
        this.tmp_member[el.mb_hashname].runs[this.cnt].run_hl_runsite = el.run_hl_runsite;

        // Add all the runners to the hl_hare variable
        if (this.tmp_member[el.mb_hashname].runs[this.cnt].hl_hare === undefined || this.tmp_member[el.mb_hashname].runs[this.cnt].hl_hare === null) {
          this.tmp_member[el.mb_hashname].runs[this.cnt].hl_hare = el.run_mb_hashname;
        }
        else {
          this.tmp_member[el.mb_hashname].runs[this.cnt].hl_hare = this.tmp_member[el.mb_hashname].runs[this.cnt].hl_hare + "," + el.run_mb_hashname;
        }
        this.hl_id = el.run_hl_id;
      });

      this.tmp_member.sort(function (a, b) {
        return a.recent_hl_datetime - b.recent_hl_datetime;
      });
      this.hares = Object.keys(this.tmp_member);
      this.member = this.tmp_member;
      this.tmpSearchObject = this.hares;
    });

    this.listForm = this.formBuilder.group({
    });

  }
  private addSelection(member: any) {
    console.log("HareComponent addSelection");

    let index = this.selectedMember.findIndex((x) => x.mb_hashname === member.mb_hashname);
    if (this.selectedMember.length > 0 && this.type === "S") {
      let alert = this.alertCtrl.create({
        "buttons": [
          {
            "role": "cancel",
            "text": "Ok",
          },
        ],
        "message": "You can only select one Hashman",
      });
      alert.present();
    }
    else {
      if (index === -1) {
        this.selectedMember.push(member);
        console.log("xHareComponent this.selectedMember", this.selectedMember);
      }
    }
  }

  private viewMemberStatus(memberStatus: number) {
    console.log("HareComponent viewMemberStatus");
    this.st_id = memberStatus;
    this.onInitPage();
  }

  private goback() {
    this.navCtrl.pop();
  }

  private addSelected() {
    console.log("HareComponent addSelected");
    this.viewCtrl.dismiss(this.selectedMember);
  }
  private deleteSelection(member: Member) {
    console.log("HareComponent deleteSelection");
    this.selectedMember = this.selectedMember.filter((el) => member.mb_hashname != el.mb_hashname);
  }

  private search(searchbar) {
    console.log("HareComponent search");
    let q = searchbar.target.value;
    if (q.trim() === "") {
      this.hares = this.tmpSearchObject;
      return;
    }
    console.error("I am here", this.member);
    this.hares = this.hares.filter((arrayEl) => (arrayEl.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1)
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/harecomponent/harecomponent.ts